export enum eDiscountType {
  ReissueDiscount = 'REISSUE_DISCOUNT',
}
